import { BasicStyledComponent, DSTeamMember } from 'shared-definitions/types'
import styleUtils from 'shared-components/styles/util.module.css'
import clsx from 'clsx'
import styles from './AuthorBig.module.css'
import AppImage from 'shared-components/ui/AppImage'
import SocialIcon from 'shared-components/service/SocialIcon'
import Linked from 'shared-components/service/Linked'
import { htmlReactParse } from 'shared-code/html'

interface AuthorBigProps extends BasicStyledComponent {
  item: DSTeamMember
}

const AuthorBig: React.VFC<AuthorBigProps> = ({ className, item }) => (
  <article className={clsx(styles.container, className)}>
    <div className={styles.imageCont}>
      {item.image ? (
        <AppImage
          layout="responsive"
          className={styles.image}
          image={item.image}
          ratio={{ w: 1, h: 1 }}
          sizes={100}
        />
      ) : null}
    </div>
    <h1 className={clsx(styleUtils.pageTitle, styles.title)}>{item.name}</h1>
    <div className={styles.description}>
      {item.description ? htmlReactParse(item.description) : null}
    </div>
    <div className={styles.socials}>
      {item.socials.map((social, index) => (
        <Linked key={index} {...social.pLink} title={social.title} className={styles.socialLink}>
          <SocialIcon icon={social.icon} className={styles.socialIcon} />
        </Linked>
      ))}
    </div>
  </article>
)

export default AuthorBig
